import axios from "axios";

// Determine the base URL based on environment
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "https://ndss-oneunion-server.vercel.app/api";
const API_DEPLOYED_URL = process.env.REACT_APP_API_DEPLOYED_URL || "https://ndss-one-union-dashboard.vercel.app";

console.log("process.env.REACT_APP_API_BASE_URL", process.env.REACT_APP_API_BASE_URL);
console.log("process.env.REACT_APP_API_DEPLOYED_URL", process.env.REACT_APP_API_DEPLOYED_URL);

export const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor to handle authentication errors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Check if this is an external link authentication error
      const config = error.config;
      if (config.url && config.url.includes('/external-links/')) {
        // Extract linkId from URL
        const match = config.url.match(/\/external-links\/([^\/]+)/);
        if (match) {
          const linkId = match[1];
          // Clear stored external token
          localStorage.removeItem(`external_token_${linkId}`);
          localStorage.removeItem(`external_token_expiry_${linkId}`);

          // If we're on the guest estimate page, reload to show auth form
          if (window.location.pathname.includes('/guest-estimate/')) {
            window.location.reload();
            return Promise.reject(error);
          }
        }
      }

      // For regular authentication errors, you might want to handle differently
      // This preserves your existing auth flow
      console.log('Authentication error:', error.response?.data);
    }

    return Promise.reject(error);
  }
);

export { API_BASE_URL, API_DEPLOYED_URL };